__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "new-mfe-template";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.5", () => (Promise.all([__webpack_require__.e(513), __webpack_require__.e(459), __webpack_require__.e(328)]).then(() => (() => (__webpack_require__(328))))));
			register("@emotion/styled", "11.10.5", () => (Promise.all([__webpack_require__.e(459), __webpack_require__.e(373), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(5903))))));
			register("@mui/material", "5.10.12", () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(7), __webpack_require__.e(513), __webpack_require__.e(806), __webpack_require__.e(459), __webpack_require__.e(445), __webpack_require__.e(373), __webpack_require__.e(821), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(6806))))));
			register("@mui/x-data-grid", "5.17.9", () => (Promise.all([__webpack_require__.e(896), __webpack_require__.e(7), __webpack_require__.e(807), __webpack_require__.e(459), __webpack_require__.e(445), __webpack_require__.e(373), __webpack_require__.e(821), __webpack_require__.e(431), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(2807))))));
			register("@reduxjs/toolkit", "1.8.6", () => (__webpack_require__.e(877).then(() => (() => (__webpack_require__(877))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(854).then(() => (() => (__webpack_require__(854))))));
			register("exceljs", "4.3.0", () => (__webpack_require__.e(223).then(() => (() => (__webpack_require__(9223))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(70).then(() => (() => (__webpack_require__(7070))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(3536))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(459)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "8.0.4", () => (Promise.all([__webpack_require__.e(166), __webpack_require__.e(459), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(2166))))));
			register("react-router-dom", "6.4.3", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(459)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			initExternal(5311);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};